import './OnboardingPages.scss';

import React from 'react';
import HandicaddieLogo from "../../../icons/HandicaddieLogo";
import {Formik} from "formik";
import {useLocation, useNavigate} from "react-router-dom";
import * as yup from "yup";
import {CredentialsService} from "../../../services/api/CredientialsService";
import {LOGIN, REGISTER_EMAIL_CONFIRM} from "../../../services/PageUtils";
import FormContainer from "../components/FormContainer";
import ErrorBox from "../components/ErrorBox";
import Button from "../../../components/Button";
import {useApiRequest} from "../../../hooks/useApiRequest";

interface Props {

}

const RegisterCredentials = ({}: Props) => {

    const location: any = useLocation();
    const navigate = useNavigate();

    const { createCredentials } = CredentialsService();

    const { execute: register, loading, errMsg } = useApiRequest(createCredentials);

    const schema = yup.object().shape({
        email: yup.string().email().required("Email is required"),
        password: yup.string()
            .required("Password is required")
            .matches(/^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$/,
                "Password should contain, at least: 8 characters, 1 uppercase letter, 1 lowercase letter, 1 number"),
        passwordConfirmation: yup
            .string()
            .required("Password confirmation is required")
            .oneOf([yup.ref("password")], "Passwords must match"),
    });

    const getEmailFromUrl = () => {
        let query = location.search.substring(1);
        let vars = query.split('&');
        for (let i = 0; i < vars.length; i++) {
            let pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == 'email') {
                return decodeURIComponent(pair[1]);
            }
        }
        return "";
    };

    const submitForm = async (values: any) => {
        let resp = await register({
            email: values.email,
            password: values.password
        });

        if (!resp || resp.error) {
            return;
        }

        navigate(REGISTER_EMAIL_CONFIRM, {
            state: {
                email: values.email,
                password: values.password,
            },
        });
    };

    let emailFromUrl = getEmailFromUrl();

    const goToLogin = () => {
        navigate(LOGIN);
    }

    return (
        <FormContainer additionalStyles={{ justifyContent: 'space-between' }}>
            <div>
                <div className={"header_logoContainer"}>
                <HandicaddieLogo size={'lg'}/>
            </div>

            <div>
                <span className={"heading"}>Register</span>
            </div>

            <Formik
                validationSchema={schema}
                onSubmit={submitForm}
                initialValues={{
                    email: emailFromUrl,
                    password: "",
                    passwordConfirmation: "",
                }}
            >
                {({
                      handleSubmit,
                      handleChange,
                      handleBlur,
                      values,
                      touched,
                      isValid,
                      errors,
                  }) => (
                    <form onSubmit={handleSubmit}>
                        <h3>Email</h3>
                        <input
                            className="onboarding_input"
                            type="email"
                            name="email"
                            placeholder="Email address"
                            value={location?.state?.email}
                            onBlur={handleBlur}
                            onChange={handleChange}
                        />
                        {touched.email && errors.email && (
                            <ErrorBox text={errors.email} />
                        )}

                        <h3 className={"onboarding_labelWithExplanation"}>Password</h3>
                        <span className={"onboarding_explanation"}>
                            Now you can enter your password for your account.
                        </span>
                        <div style={{ marginTop: '0.25em' }}>
                            <input
                                required
                                className="onboarding_input"
                                type="password"
                                name="password"
                                placeholder="Password"
                                value={values.password}
                                onBlur={handleBlur}
                                onChange={handleChange}
                            />
                            {touched.password && errors.password && (
                                <ErrorBox text={errors.password} />
                            )}
                        </div>
                        <div style={{ marginTop: '0.25em' }}>
                            <input
                                required
                                className="onboarding_input"
                                type="password"
                                name="passwordConfirmation"
                                placeholder="Password Confirmation"
                                onBlur={handleBlur}
                                value={values.passwordConfirmation}
                                onChange={handleChange}
                            />
                            {touched.passwordConfirmation && errors.passwordConfirmation && (
                                <ErrorBox text={errors.passwordConfirmation} />
                            )}
                        </div>

                        <ErrorBox text={errMsg} />
                        <div style={{ marginTop: '1.5em' }}>
                            <Button text={"REGISTER"} type="submit" disabled={loading} />
                        </div>
                    </form>
                )}
            </Formik>
            </div>

            <div className={"login_registerContainer"}>
                <div className={"login_line"}/>
                <span className={"login_registerTxt"}>Or, already have an account?</span>
                <Button text={"GO TO LOGIN"} onClick={goToLogin} variant={"secondary"} />
            </div>
        </FormContainer>
    )
}

export default RegisterCredentials;